import Wix from '../services/wix-sdk-polyfill';

export const APP_LIFECYCLE_STATUS = '__APP_LIFECYCLE_STATUS__';

export const LOADING_SCRIPTS = 'LOADING_SCRIPTS'; // eslint-disable-line no-unused-vars
export const APP_LOADING_IN_PROGRESS = 'APP_LOADING_IN_PROGRESS';
export const APP_LOADED_BEFORE_IMAGES = 'APP_LOADED_BEFORE_IMAGES';
export const APP_LOADED = 'APP_LOADED';

export const APP_LOADING_IN_PROGRESS_STEP = 0;
export const APP_LOADED_BEFORE_IMAGES_STEP = 1;

const createSetStatus = (status, step) => ({ logInSdk = false } = {}) => {
  (window || {})[APP_LIFECYCLE_STATUS] = status;

  if (status === APP_LOADED && logInSdk) {
    Wix.Performance.applicationLoaded();
  }

  if (step !== undefined && logInSdk) {
    Wix.Performance.applicationLoadingStep(step, status);
  }
};

export const appIsLoading = createSetStatus(APP_LOADING_IN_PROGRESS, APP_LOADING_IN_PROGRESS_STEP);
export const appLoadedBeforeImages = createSetStatus(APP_LOADED_BEFORE_IMAGES, APP_LOADED_BEFORE_IMAGES_STEP);
export const appLoaded = createSetStatus(APP_LOADED);



// WEBPACK FOOTER //
// ./app/services/app-lifecycle-service.js